import { render, staticRenderFns } from "./Kefu.vue?vue&type=template&id=435f8cd0&scoped=true"
import script from "./Kefu.vue?vue&type=script&lang=js"
export * from "./Kefu.vue?vue&type=script&lang=js"
import style0 from "./Kefu.vue?vue&type=style&index=0&id=435f8cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f8cd0",
  null
  
)

export default component.exports